<template>
    <div class="abhs-container">
        <!-- 添加TopBar组件 -->
        <TopBar :user="user" :apps="apps" />

        <!-- 页面头部 -->
        <div class="abhs-header">
            <h1 class="abhs-title">
                <i class="icon">📚</i>
                默写模式
            </h1>
        </div>

        <!-- 主要内容区域 -->
        <div class="abhs-main" v-if="!loading">
            <!-- 优化的导航链接 -->
            <div class="navigation-links">
                <div class="nav-card" @click="goToGallery('E')">
                    <div class="nav-icon">🔤</div>
                    <h3>英语单词库</h3>
                    <p>海量英语单词库，涵盖从小学到大学各个阶段</p>
                    <div class="nav-arrow">→</div>
                </div>
                <div class="nav-card" @click="goToGallery('C')">
                    <div class="nav-icon">📖</div>
                    <h3>中文字词库</h3>
                    <p>丰富的中文字词库，包括小学到高中的字词</p>
                    <div class="nav-arrow">→</div>
                </div>
            </div>

            <!-- 空状态 -->
            <div class="empty-state" v-if="false">
                <p>暂无单词表，请先导入单词表</p>
                <button @click="importWordList" class="import-btn">导入单词表</button>
            </div>
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-overlay">
            <div class="loading-spinner">
                <div class="spinner"></div>
                <p>{{ loadingMessage }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import TopBar from '@/components/TopBar.vue'
import AuthService from '@/services/authService.js'
// import UserService from '@/services/userService.js'
import UserMainService from '@/services/userMainService.js'
import config from '@/config'

export default {
    name: 'AbhsView',
    components: {
        TopBar
    },
    setup() {
        const router = useRouter()

        // 响应式数据
        const user = ref({
            name: '用户名',
            id: 1,
            userType: 1,
            avatar: require('@/assets/logo.png')
        })

        const apps = ref([])
        const loading = ref(true)
        const loadingMessage = ref('加载中...')
        const bookType = ref('abhsWords') // 默认为英文单词

        // 加载用户信息
        const loadUserInfo = () => {
            const currentUser = AuthService.getCurrentUser()
            if (currentUser) {
                console.log('当前用户信息:', currentUser);
                user.value.name = currentUser.nickname || currentUser.username || '用户名';
                user.value.id = currentUser.userid || currentUser.id || 1;
                user.value.userType = currentUser.userType || 1;
                console.log("icon:", currentUser.icon);
                // 如果有头像信息，则更新头像路径
                if (currentUser.icon) {
                    // 规范化路径分隔符，将反斜杠转换为正斜杠
                    const normalizedIcon = currentUser.icon.replace(/\\/g, '/');
                    console.log('规范化后的icon路径:', normalizedIcon);

                    // 构建完整的后端服务器地址，确保头像从8000端口获取
                    if (normalizedIcon.startsWith('http')) {
                        console.log('完整URL:', normalizedIcon);
                        // 如果已经是完整URL，则直接使用
                        user.value.avatar = normalizedIcon;
                    } else if (normalizedIcon.startsWith('/extra-files/uploads/')) {
                        console.log('extra-files URL:', normalizedIcon);
                        // 从后端服务器的8000端口获取头像
                        user.value.avatar = `${config.API_BASE_URL}${normalizedIcon}`;
                    } else if (normalizedIcon.startsWith('uploads/')) {
                        console.log('uploads URL:', normalizedIcon);
                        // 从后端服务器的8000端口获取头像
                        //user.value.avatar = `${config.API_BASE_URL}/extra-files/${normalizedIcon}`;

                        user.value.avatar = `${config.API_BASE_URL}/extra-files/${normalizedIcon}`;
                        //查看地址：`${config.API_BASE_URL}/extra-files/${normalizedIcon}`;
                        console.log('user.value.avatar', user.value.avatar);
                    } else {
                        console.log('img URL:', normalizedIcon);
                        user.value.avatar = `${config.API_BASE_URL}/extra-files/uploads/${normalizedIcon}`;
                    }
                } else {
                    console.log('使用默认头像');
                    // 使用默认头像
                    user.value.avatar = require('@/assets/logo.png');
                }
            }
        }

        // 加载应用信息
        const loadAppInfo = async () => {
            try {
                const response = await UserMainService.getAllApps(user.value.userType)
                if (response.status === 200 && response.apps) {
                    apps.value = response.apps.map(app => ({
                        id: app.id,
                        name: app.name,
                        desc: app.desc,
                        link: app.name === '快速抢答' ? '/abhs' : app.link,
                        icon: app.icon || 'code',
                        used: app.used || false
                    }))
                }
            } catch (error) {
                console.error('获取应用数据失败:', error)
                apps.value = [
                    { id: 1, name: 'OJ练习', desc: '在线编程练习', link: '/CppOJ/', icon: 'code', used: true },
                    { id: 2, name: '任务清单', desc: '待办事项管理', link: '/todo', icon: 'list', used: true },
                    { id: 3, name: '时间线', desc: '时间记录管理', link: '/TimeLine/', icon: 'timeline', used: false },
                    { id: 4, name: '知识图谱', desc: '知识关系展示', link: '/Graph/', icon: 'share', used: false },
                    { id: 5, name: '快速抢答', desc: '抢答与记忆训练', link: '/abhs', icon: 'quiz', used: false },
                    { id: 6, name: '文件管理', desc: '文件上传下载', link: '/FileManage/', icon: 'folder', used: false },
                    { id: 7, name: '数据可视化', desc: '数据图表展示', link: '/DataVisual/', icon: 'bar_chart', used: false }
                ]
            }
        }

        // 导入单词表
        const importWordList = () => {
            alert('导入单词表功能正在开发中...')
        }

        // 前往词库页面
        const goToGallery = (type) => {
            if (type === 'E') {
                router.push('/abhs/galleryE')
            } else {
                router.push('/abhs/galleryC')
            }
        }

        // 初始化应用
        const initApp = async () => {
            try {
                console.log('ABHS系统初始化中...')

                // 加载用户信息和应用信息
                loadUserInfo()
                await loadAppInfo()

                console.log('ABHS系统初始化完成')
            } catch (error) {
                console.error('ABHS系统初始化失败:', error)
            } finally {
                loading.value = false
            }
        }

        // 组件挂载时初始化
        onMounted(() => {
            initApp()
        })

        return {
            user,
            apps,
            loading,
            loadingMessage,
            bookType,
            importWordList,
            goToGallery
        }
    }
}
</script>

<style scoped>
.abhs-container {
    min-height: 100vh;
    background-color: #f5f5f5;
}

.abhs-header {
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.abhs-title {
    margin: 0;
    font-size: 24px;
    color: #333;
}

.abhs-main {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

/* 优化的导航链接样式 */
.navigation-links {
    display: flex;
    gap: 30px;
    justify-content: center;
    margin-top: 50px;
}

.nav-card {
    flex: 1;
    max-width: 400px;
    background-color: #fff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.nav-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.nav-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #007bff, #28a745);
}

.nav-icon {
    font-size: 48px;
    text-align: center;
    margin-bottom: 20px;
}

.nav-card h3 {
    text-align: center;
    color: #333;
    margin: 0 0 15px 0;
    font-size: 22px;
}

.nav-card p {
    text-align: center;
    color: #666;
    margin: 0 0 20px 0;
    font-size: 16px;
    line-height: 1.5;
}

.nav-arrow {
    text-align: center;
    font-size: 24px;
    color: #007bff;
    font-weight: bold;
}

.empty-state {
    text-align: center;
    padding: 50px 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.empty-state p {
    font-size: 18px;
    color: #666;
    margin-bottom: 20px;
}

.import-btn {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

.import-btn:hover {
    background-color: #218838;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.loading-spinner {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    text-align: center;
}

.spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin: 0 auto 15px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .abhs-main {
        padding: 10px;
    }

    .navigation-links {
        flex-direction: column;
        gap: 20px;
    }

    .nav-card {
        max-width: 100%;
    }
}
</style>